import BaseCheckbox from './Inputs/BaseCheckbox.vue';
import BaseAlert from './BaseAlert.vue';
import IconCheckbox from './Inputs/IconCheckbox.vue';
import BaseRadio from './Inputs/BaseRadio.vue';
import BaseInput from './Inputs/BaseInput.vue';
import TagsInput from './Inputs/TagsInput.vue';
import BaseSwitch from './BaseSwitch.vue';
import Badge from './Badge';
import BaseProgress from './BaseProgress.vue';
import BaseButton from './BaseButton.vue';

import BaseDropdown from './BaseDropdown.vue';
import BaseTable from './BaseTable.vue';

import Card from './Cards/Card.vue';
import StatsCard from './Cards/StatsCard.vue';
import BaseNav from './Navbar/BaseNav';
import NavbarToggleButton from './Navbar/NavbarToggleButton';

import Breadcrumb from './Breadcrumb/Breadcrumb.vue';
import BreadcrumbItem from './Breadcrumb/BreadcrumbItem.vue';
import RouteBreadCrumb from './Breadcrumb/RouteBreadcrumb.vue';
// import ImageUpload from './ImageUpload';
// import TimeLine from './Timeline/TimeLine.vue';
// import TimeLineItem from './Timeline/TimeLineItem.vue';
import TabPane from './Tabs/Tab.vue';
import Tabs from './Tabs/Tabs.vue';
import Collapse from './Collapse/Collapse.vue';
import CollapseItem from './Collapse/CollapseItem.vue';
import Modal from './Modal.vue';
import Slider from './Slider.vue';
import SimpleWizard from './Wizard/Wizard.vue';
import WizardTab from './Wizard/WizardTab.vue';
import LoadingPanel from './LoadingPanel.vue';
// import AsyncWorldMap from './WorldMap/AsyncWorldMap.vue';

import BasePagination from './BasePagination.vue';

import SidebarPlugin from './SidebarPlugin';

// import AnimatedNumber from './AnimatedNumber';

export {
  BaseCheckbox,
  IconCheckbox,
  BaseSwitch,
  Badge,
  BaseAlert,
  BaseProgress,
  BasePagination,
  BaseRadio,
  BaseInput,
  TagsInput,
  Card,
  StatsCard,
  BaseTable,
  BaseDropdown,
  // ImageUpload,
  SidebarPlugin,
  BaseNav,
  NavbarToggleButton,
  Breadcrumb,
  BreadcrumbItem,
  RouteBreadCrumb,
  // TimeLine,
  // TimeLineItem,
  TabPane,
  Tabs,
  Modal,
  Slider,
  SimpleWizard,
  WizardTab,
  // AnimatedNumber,
  BaseButton,
  Collapse,
  CollapseItem,
  LoadingPanel,
  // AsyncWorldMap,
};
